import * as L from 'leaflet';
import $ from 'jquery';
import slider from './slider';

const leaflet = {
  footerMap: () => {
    /* CATCH the points */
    let infosContainer = document.querySelectorAll('.footer--map--info');
    let data = [];

    Array.prototype.forEach.call(infosContainer, (el, i) => {
      let pos = el.getAttribute('data-pos');
      let posArray = pos.split(', ');
      data.push([posArray[0], posArray[1]])
    });
    /* CATCH the points */

    if (typeof data[0] == 'undefined') {
      return;
    }

    _leafletPrivate.map.set();

    _leafletPrivate.map.tile.set('openStreetMap');

    data.map( (e, i) => {
      let icon = _leafletPrivate.marker.icon.get(i, i == 0 && data.length > 1);

      _leafletPrivate.marker.add(i,[e[0], e[1]], icon);
    });

    _leafletPrivate.marker.center();

    _leafletPrivate.marker.addEvent($('.footer--map__wrapper'));

    /* ADD event when slide */
    $('.footer--map__wrapper').on('afterChange', (event, slick, currentSlide) => {
      _leafletPrivate.marker.icon.set(_leafletPrivate.marker.activeIndex, false);

      _leafletPrivate.map.center(currentSlide);
      _leafletPrivate.marker.icon.set(_leafletPrivate.marker.activeIndex, true);

      _leafletPrivate.marker.addEvent($('.footer--map__wrapper'));
    });
  }
};

const _leafletPrivate = {
  map : {
    object : null,
    id : 'map-container',
    minZoom : 7,
    zoom : 8,
    set : (centerPoint) => {
      _leafletPrivate.map.object = L.map(
        _leafletPrivate.map.id,
        {
          minZoom: _leafletPrivate.map.minZoom,
          scrollWheelZoom: false
        }
      );
    },
    center : (activeIndex) => {
      _leafletPrivate.marker.activeIndex = activeIndex;
      let center = _leafletPrivate.marker.markers[activeIndex].getLatLng();
      _leafletPrivate.map.object.setView(center);
    },
    tile : {
      openStreetMap : {
        url : 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        options : {
          attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>',
          subdomains: ['a','b','c']
        }
      },
      set : (tileName) => {
        L.tileLayer(
          _leafletPrivate.map.tile[tileName].url,
          _leafletPrivate.map.tile[tileName].options
        ).addTo(_leafletPrivate.map.object);
      }
    },
  },
  marker : {
    activeIndex : 0,
    markers : [],
    add : (slideNo, point, icon) => {
      _leafletPrivate.marker.markers[slideNo] = L.marker(
        point,
        {icon: icon}
       ).addTo(_leafletPrivate.map.object);
    },
    center : () => {
      let group = new L.featureGroup(_leafletPrivate.marker.markers);

      _leafletPrivate.map.object.fitBounds(group.getBounds(),{padding: [10, 30]})
    },
    addEvent : (sliderHtmltag) => {
      slider.addEventToSlide('.' + _leafletPrivate.marker.icon.className + ' button', sliderHtmltag);
    },
    icon : {
      src : '/themes/custom/ifapme_liege_theme/images/marker.svg',
      className : 'marker-center',
      get : (slideNo, isActive) => {
        return new L.divIcon({
          iconSize: [50, 60],
          iconAnchor: [25, 30],
          popupAnchor: [0, 0],
          className: _leafletPrivate.marker.icon.className + ' ' + (isActive ? 'marker-active' : 'marker-inactive'),
          html: '<button data-slide="' + slideNo + '"><img alt="marker" src="' + _leafletPrivate.marker.icon.src + '" /></button>'
        });
      },
      set : (sliderNo, isActive) => {
        let icon = _leafletPrivate.marker.icon.get(sliderNo, isActive);
        _leafletPrivate.marker.markers[sliderNo].setIcon(icon);
      }
    }
  }
};

export default leaflet;
